import React, { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import ReactLoading from 'react-loading';

import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

import { SessionContext } from "../context/session-context";

const useStyles = makeStyles({
    registerButton: {
        width:200,
    },
    textField:{
      width:'90%',
      '& .MuiOutlinedInput-root':{
        height:36,
      }
    },
    actionButton: {
      color: '#FFFFFF',
      backgroundColor: '#0C4C35',
      '&:hover': {
        color: '#FFFFFF',
        backgroundColor: '#63D764',
      },
      marginTop: 4,
      marginRight: 8,
      padding: '2px 10px 2px 10px'
    },
    cancelButton: {
      color: '#0C4C35',
      border: '1px solid #0C4C35',
      '&:hover': {
        color: '#63D764',
        border: '1px solid #63D764',
      },
      marginTop: 4,
      marginRight: 8,
      padding: '2px 10px 2px 10px'
    },
    divider:{
      marginTop: 10,
      marginBottom: 10,
      height: 2,
    }

});

var handleError = function (err) {
  console.log(err);
  return new Response(JSON.stringify({
    code: 400,
    message: 'Stupid network Error'
  }));
};

export default function RegisterDialog(props) {
  const classes = useStyles();
  const {isRegister, onClose} = props;
  const [state, dispatch] = useContext(SessionContext);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState('');
  const [hasNameError, setHasNameError] = useState(false);
  const [hasNameErrorLabel, setHasNameErrorLabel] = useState('');
  const [email, setEmail] = useState('');
  const [hasEmailError, setHasEmailError] = useState(false);
  const [hasEmailErrorLabel, setHasEmailErrorLabel] = useState('');
  const [password1, setPassword1] = useState('');
  const [hasPassword1Error, setHasPassword1Error] = useState(false);
  const [hasPassword1ErrorLabel, setHasPassword1ErrorLabel] = useState('');
  const [password2, setPassword2] = useState('');
  const [hasPassword2Error, setHasPassword2Error] = useState(false);
  const [hasPassword2ErrorLabel, setHasPassword2ErrorLabel] = useState('');

  const [companyname, setCompanyname] = useState('');
  const [hasCompanynameError, setHasCompanynameError] = useState(false);
  const [hasCompanynameErrorLabel, setHasCompanynameErrorLabel] = useState('');
  const [address1, setAddress1] = useState('');
  const [hasAddress1Error, setHasAddress1Error] = useState(false);
  const [hasAddress1ErrorLabel, setHasAddress1ErrorLabel] = useState('');
  const [address2, setAddress2] = useState('');
  const [city, setCity] = useState('');
  const [hasCityError, setHasCityError] = useState(false);
  const [hasCityErrorLabel, setHasCityErrorLabel] = useState('');
  const [county, setCounty] = useState('');
  const [country, setCountry] = useState('');
  const [postcode, setPostcode] = useState('');
  const [hasPostcodeError, setHasPostcodeError] = useState(false);
  const [hasPostcodeErrorLabel, setHasPostcodeErrorLabel] = useState('');
  const [telephone, setTelephone] = useState('');
  const [hasTelephoneError, setHasTelephoneError] = useState(false);
  const [hasTelephoneErrorLabel, setHasTelephoneErrorLabel] = useState('');
  const [businessType, setBusinessType] = useState('');

  const [severity, setSeverity] = useState('success');
  const [msg, setMsg] = useState('');
  const [snackOpen, setSnackOpen] = useState(false);

  const handleSubmit = (event) => {
    setLoading(true);
    let hasError = false;
    if (name.length < 1){ setHasNameError(true); setHasNameErrorLabel('Your name is required'); hasError = true;} else { setHasNameError(false); setHasNameErrorLabel('') }
    if (email.length < 1){ setHasEmailError(true); setHasEmailErrorLabel('Your email is required'); hasError = true;} else { setHasEmailError(false); setHasEmailErrorLabel('');}
    if (password1.length < 1){ setHasPassword1Error(true); setHasPassword1ErrorLabel('Password is required'); hasError = true; } else { setHasPassword1Error(false); }
    if (password2.length < 1){ setHasPassword2Error(true); setHasPassword2ErrorLabel('Please confirm your password'); hasError = true;} else { setHasPassword2Error(false); setHasPassword2ErrorLabel('');}
    if (!hasPassword2Error && password1 !== password2){ setHasPassword2Error(true); setHasPassword2ErrorLabel('Passwords do not match'); hasError = true;} else { setHasPassword2Error(false); setHasPassword2ErrorLabel('');}

    if (companyname.length < 1){ setHasCompanynameError(true); setHasCompanynameErrorLabel('Company name is required'); hasError = true; } else { setHasCompanynameError(false); setHasCompanynameErrorLabel('') }
    if (address1.length < 1){ setHasAddress1Error(true); setHasAddress1ErrorLabel('Company address is required'); hasError = true; } else { setHasAddress1Error(false); setHasAddress1ErrorLabel('') }
    if (city.length < 1){ setHasCityError(true); setHasCityErrorLabel('City / Town is required'); hasError = true; } else { setHasCityError(false); setHasCityErrorLabel('') }
    if (postcode.length < 1){ setHasPostcodeError(true); setHasPostcodeErrorLabel('Postcode is required'); hasError = true; } else { setHasPostcodeError(false); setHasPostcodeErrorLabel('') }
    if (telephone.length < 4){setHasTelephoneError(true); setHasTelephoneErrorLabel('Telephone number is required'); hasError = true; } else { setHasTelephoneError(false); setHasTelephoneErrorLabel('') }

    if (!hasError){
      console.log("recordClientRegistration called");
      const abortController = new AbortController();
      const request = {   
        companyname:companyname,
        address1:address1,
        address2:address2,
        town:city,
        county:county,
        postcode:postcode,
        country:country,
        telephone:telephone,
        username:name,
        email:email,
        pword:password1,
        utype:'manager'
      };

      let mounted = true;
      (async () => {  
          const res = await fetch(process.env.REACT_APP_FIND_API+'/company/register', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
          }).catch(handleError);
          const data = await res.json();
          if (mounted) {

            if (data.status === "success"){
              setSeverity('success')
              setMsg('Your registration request has successfully been submitted. A member of the Mapdata.uk team will be in contact shortly.')
            } else {
              setSeverity('error')
              setMsg('Your registration request has failed. Please contact the Mapdata.uk support team by email on support@mapdata.uk or telephone 020 3002 7449.')
            }
            setSnackOpen(true);
            setLoading(false);
          }
          const cleanup = () => {
              mounted = false;
              abortController.abort();
          };
          return cleanup;
      
      })();
    } else {
      setLoading(false);
    }
    event.preventDefault();
  };

  const handleClose = () => {
    setSnackOpen(false);
    onClose();
  }

  return (
      <div>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackOpen} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={severity}>
            {msg}
            </Alert>
        </Snackbar>
        <Dialog open={isRegister} onClose={onClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Register for a Mapdata.uk account</DialogTitle>
            <DialogContent>
            <Grid container>
              <Grid item xs={12}>
                <Box fontSize={14}>The Mapdata.uk mapping portal is a B2B site that has been optimised for forward thinking businesses that require reports, prints and data export for the successful running of their business.</Box>
                <Box fontSize={14}>If you are a consumer who requires a one-off planning map, utility or environmental report then please contact the support team on support@mapdata.uk who will be happy to assist.</Box>
              </Grid>
              <Grid item xs={6}>
                <TextField className={classes.textField} error={hasNameError} helperText={hasNameErrorLabel} name="name" label="Your name" size="small" margin="dense" variant="outlined" value={name} onChange={e => setName(e.target.value)} required/> 
              </Grid>
              <Grid item xs={6}>
                <TextField error={hasTelephoneError} helperText={hasTelephoneErrorLabel} className={classes.textField} name="telephone" label="Your telephone number" size="small" margin="dense" variant="outlined" value={telephone} onChange={e => setTelephone(e.target.value)} required/>
              </Grid>
              <Grid item xs={8}>
                <TextField type="email" error={hasEmailError} helperText={hasEmailErrorLabel} className={classes.textField} name="email" label="Your email" size="small" margin="dense" variant="outlined" value={email} onChange={e => setEmail(e.target.value)} required/>
              </Grid>
              <Grid item xs={4}></Grid>
              <Grid item xs={6}>
                <TextField type="password" error={hasPassword1Error} helperText={hasPassword1ErrorLabel} className={classes.textField} name="password1" label="Create account password" size="small" margin="dense" variant="outlined" value={password1} onChange={e => setPassword1(e.target.value)} required/>
              </Grid>
              <Grid item xs={6}>
                <TextField type="password" error={hasPassword2Error} helperText={hasPassword2ErrorLabel} className={classes.textField} name="password2" label="Confirm account password" size="small" margin="dense" variant="outlined" value={password2} onChange={e => setPassword2(e.target.value)} required/>
              </Grid>
              <Grid item xs={12}><Divider className={classes.divider} /></Grid>
              
              <Grid item xs={8}>
                <TextField className={classes.textField} error={hasCompanynameError} helperText={hasCompanynameErrorLabel} name="companyname" label="Company name" variant="outlined" size="small" margin="dense" value={companyname} onChange={e => setCompanyname(e.target.value)} required/>
              </Grid>
              <Grid item xs={3}></Grid>
              <Grid item xs={6}>
                <TextField className={classes.textField} error={hasAddress1Error} helperText={hasAddress1ErrorLabel} name="address1" label="Address line 1" variant="outlined" size="small" margin="dense" value={address1} onChange={e => setAddress1(e.target.value)} required />
              </Grid>
              <Grid item xs={6}>
                <TextField className={classes.textField} name="address2" label="Address line 2" variant="outlined" size="small" margin="dense" value={address2} onChange={e => setAddress2(e.target.value)} />
              </Grid>
              <Grid item xs={6}>
                <TextField className={classes.textField} error={hasCityError} helperText={hasCityErrorLabel} name="city" label="City / Town" variant="outlined" size="small" margin="dense" value={city} onChange={e => setCity(e.target.value)} required />
              </Grid>
              <Grid item xs={6}>
                <TextField className={classes.textField} name="county" label="County" variant="outlined" size="small" margin="dense" value={county} onChange={e => setCounty(e.target.value)} /> 
              </Grid>
              <Grid item xs={6}>
                <TextField className={classes.textField} name="country" label="Country" variant="outlined" size="small" margin="dense" value={country} onChange={e => setCountry(e.target.value)} />
              </Grid>
              <Grid item xs={6}>
                <TextField className={classes.textField} error={hasPostcodeError} helperText={hasPostcodeErrorLabel} name="postcode" label="Postcode" variant="outlined" size="small" margin="dense" value={postcode} onChange={e => setPostcode(e.target.value)} required />  
              </Grid>
              <Grid item xs={12}>
                <Box fontSize={14}>Please note your details will not be shared with any third party. By clicking 'Register now' you are agreeing to our <a href='https://www.mapdata.uk/terms' target='_blank' rel='noopener noreferrer' aria-label="Mapdata.uk terms and conditions">Terms and conditions</a>. You will be contacted within the next working day to confirm your registration. If you do not receive any contact from Mapdata.uk please contact our Support Team on support@mapdata.uk</Box>
              </Grid>
            </Grid>
            </DialogContent>

            <DialogActions>

              <Button className={classes.cancelButton} onClick={onClose}>
                Cancel
              </Button>

            {loading ? (
                <Box className={classes.actionButton} justifyContent="center"><ReactLoading className={classes.loadingImg} type={"bars"} color={"#63D764"} /></Box>
              ) : (
              <Button className={classes.actionButton} onClick={handleSubmit}>
                Register
              </Button>
            )}

            </DialogActions>
        </Dialog>
      

    </div>
  );
}